import * as React from 'react';
import styled from 'styled-components';
import { DSNotifier } from '../Notifier';
import { DSTypography } from '../Typography';
import { DSIconButton } from '../../Generic/Buttons/DSIconButton';

export type IssueAndResolutions = { explainIssue: string; provideResolution: string[] };
export type IssuesAndResolutions = IssueAndResolutions[];

const ExclamationIcon = styled.i.attrs(() => ({ className: 'fas fa-bell' }))`
    color: ${({ theme }) => theme.palette.secondary.main};
`;

export const IssueNotifier: React.FC<{ issues: IssuesAndResolutions }> = ({ issues: messages }) => (
    <DSNotifier
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        render={({ onClick }) => (
            <DSIconButton role="button" size="small" onClick={onClick}>
                <ExclamationIcon />
            </DSIconButton>
        )}
        transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
        <div style={{ maxWidth: '400px', padding: '12px' }}>
            {messages.map((message, mIndex) => (
                <div key={`message-${mIndex}`}>
                    <DSTypography color="error" component="p" gutterBottom variant="body1">
                        {message.explainIssue}
                    </DSTypography>
                    {message.provideResolution.map((sentence, sIndex) => (
                        <DSTypography
                            color="textSecondary"
                            component="p"
                            gutterBottom
                            key={`sentence-${mIndex}-${sIndex}`}
                            variant="caption"
                        >
                            {sentence}
                        </DSTypography>
                    ))}
                </div>
            ))}
        </div>
    </DSNotifier>
);
IssueNotifier.displayName = 'IssueNotifier';
